export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkInicio: "nav-link-inicio",
  linkActividades: "nav-link-actividades",
  linkSobre: "nav-link-sobre",
  linkContacto: "nav-link-contacto",
  reservarBtn: "nav-reservar-btn",
  langToggle: "nav-lang-toggle",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const HERO = {
  section: "hero-section",
  ctaPrimary: "hero-cta-reservar",
  ctaSecondary: "hero-cta-actividades",
};

export const ACTIVITIES = {
  section: "activities-section",
  cardBarrancos: "activity-card-barrancos",
  cardCuevas: "activity-card-cuevas",
  cardFerratas: "activity-card-ferratas",
  detailBookBtn: "activity-detail-book-btn",
};

export const BOOKING = {
  section: "booking-section",
  form: "booking-form",
  inputName: "booking-input-name",
  inputEmail: "booking-input-email",
  inputPhone: "booking-input-phone",
  selectActivity: "booking-select-activity",
  inputDate: "booking-input-date",
  inputParticipants: "booking-input-participants",
  selectLevel: "booking-select-level",
  inputMessage: "booking-input-message",
  submit: "booking-submit-btn",
  success: "booking-success-msg",
};

export const CONTACT = {
  section: "contact-section",
  email: "contact-email-link",
};

export const FOOTER = {
  root: "footer-root",
};
